import React, { cloneElement, forwardRef, ReactElement, useCallback } from 'react';
import { SCP } from 'ia-react-core/~/interfaces/SCP';

import {
  StyledListItem,
} from './Menu.styles';

interface MenuListItemProps extends SCP<'li'> {
  item: ReactElement;
  index: number;
  selectedItemIndex: number;
  isLast: boolean;
  onItemClick?: (event: MouseEvent) => void;
}

const MenuListItem = forwardRef<HTMLLIElement, MenuListItemProps>(({ item, index, selectedItemIndex, isLast, onItemClick }, ref) => {
  const handleClick = useCallback((event: MouseEvent) => {
    onItemClick(event);
    if (item.props.onClick)item.props.onClick(event);
  }, [item.props, onItemClick]);

  return (
    <StyledListItem>
      {cloneElement(item, {
        isSelected: index === selectedItemIndex,
        tabIndex: -1,
        isLast,
        ref,
        onClick: handleClick,
      })}
    </StyledListItem>
  );
});

export default MenuListItem;
